import { Breadcrumb, ConfigProvider, Flex, Space, Tabs } from "antd";
import { MainLayout } from "components/layouts";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import CreateProjectInformation from "./CreateTab/CreateProjectInformation";

const CreateSettingProject = ({
    onSubmit = () => { },
    employeeOptions = [],
    PROJECT_STATUS = []
}) => {
    const { t } = useTranslation();

    return (
        <MainLayout>
            <Space size={24} direction="vertical" style={{ width: "100%" }}>
                <Breadcrumb items={[
                    { title: t("home.header"), href: "/" },
                    { title: t("setting_timesheet.header"), href: "/setting_timesheet/setting_project" },
                    { title: t("setting_project.header"), href: "/setting_timesheet/setting_project" },
                    { title: t("setting_project.label.create") },
                ]}
                />
                <Flex vertical>
                    <h2>{t("setting_project.label.create")}</h2>
                    <span style={{ color: "#667085" }}>{t("setting_project.label.detail")}</span>
                </Flex>

                <ConfigProvider
                    theme={{
                        components: {
                            Tabs: {
                                itemHoverColor: "var(--tab-color)",
                                itemActiveColor: "var(--tab-color)"
                            },
                        },
                    }}
                >
                    <Tabs destroyInactiveTabPane={true} defaultActiveKey="project_info">
                        {
                            <Tabs.TabPane tab={t('setting_project.label.project_info')} key="project_info">
                                <CreateProjectInformation onSubmit={onSubmit} employeeOptions={employeeOptions} PROJECT_STATUS={PROJECT_STATUS} />
                            </Tabs.TabPane>
                        }
                    </Tabs>
                </ConfigProvider>
            </Space>
        </MainLayout>
    )
}

export default CreateSettingProject;